import { ProductType } from '../enums/productType'

export const isInvoiceProductType = (value?: string | number): value is ProductType => {
  return Object.values(ProductType).includes(value as ProductType)
}
